<template>
  <div>
    <v-flex xs12 md12 sm12>
      <v-card  hover>
        <v-card-title>
          <h2>Informações da Obra</h2>
        </v-card-title>
          <v-divider></v-divider>
        <obra_form_info :workdata="work" @work_data="workData" />
      </v-card>
    </v-flex>
    <v-flex xs12 md12 sm12 py-3>
      <v-card  hover>
        <v-card-title right>
          <h2>Informações de Direitos</h2>
          <v-spacer ></v-spacer>
          <!--v-switch row v-model="tile" label="Essa obra está editada?"></v-switch-->        
        </v-card-title>

        <v-divider></v-divider>

        <compositor_search @work_type="workType" :worktype="work.type" :publishersdata="publishers" @publishers_data="publisherData" :composersdata="composers" @composers_data="composerData" />
      </v-card>
    </v-flex>

    <modal_message
      :dialog_opened="modal_dialog.dialog_opened"
      :title="modal_dialog.title"
      :message="modal_dialog.message"
      :btn_1_text="modal_dialog.btn_1_text"
      :btn_2_text="modal_dialog.btn_2_text"
      @btn_1_clicked="modal_dialog.btn_1_evnt"
      @btn_2_clicked="modal_dialog.btn_1_evnt"
    />
  </div>
</template>

<script>
import obra_form_info from "./obra_form_info";
import compositor_search from "../compositores/compositor_search";
import WorkService from "../../app/Rest/work";
import modal_message from "../shared/modal_message";

const workService = WorkService.build();

export default {
  components: {
    obra_form_info,
    compositor_search,
    modal_message
  },
  props: {
    obra_id: Number
  },
  data(){
      return {
      tabs: null,
      work: {},
      composers: [],
      publishers: [],
      modal_dialog: {
        dialog_opened: false,
        title: null,
        message: null,
        btn_1_text: null,
        btn_2_text: null,
        btn_1_evnt: function() {},
         btn_2_evnt: function() {}
    }
    }
  },
  created() {
    if (!this.obra_id) {
      return;
    }
    workService.getOne(this.obra_id).then(e => {
      this.work = e.items.work;
      this.composers = e.items.composers;
      this.publishers = e.items.publishers;
    });
  },
  methods: {
    salvar() {
      console.log( this.work.type );
      if(!this.work.type){

        this.modal_dialog.title = "Atenção!"; 
        this.modal_dialog.message = "É obrigatório marcar se a obra é direto com o autor ou se está editada.";
        this.modal_dialog.btn_1_text = "ok, entendi";
        this.modal_dialog.btn_1_evnt = e => {
          this.modal_dialog.dialog_opened = false;          
        };
        this.modal_dialog.dialog_opened = true;              
        return;
      }

      if (this.composers.length) {
        this.work.composers = this.composers;        
      }

      if(this.publishers.length){
        this.work.publishers = this.publishers;
      }

      this.$store.dispatch("loading_full");
      workService.salvar(this.work).then(e => {
        if (e.items) {
          this.composers = e.items.composers;
          this.work = e.items.work;
          this.$store.dispatch("obras_update");

          this.modal_dialog.title = "Salvo com sucesso!";           
          this.modal_dialog.btn_1_text = "obrigado";
          this.modal_dialog.btn_1_evnt = e => {
            this.modal_dialog.dialog_opened = false;          
          };
          this.modal_dialog.dialog_opened = true;   
          
        }
        

      }).finally(e=>{
        this.$store.dispatch("loading_full");
      });
    },
  /**
   * Chamada quando é marcada o tipo de obra: direto com o autor ou se está editada
   */
    publisherData(p){
      this.publishers = p;
    },
    workType(type){
      this.work.type = type;
    },
    composerData(composers) {
      this.composers = composers;
    },
    workData(work) {
      this.work = work;
    }
  }
};
</script>